/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M27.6 2.4c1.1 0 2.2.1 3.2.3-5.3 3.6-8.7 9.7-8.7 16.5 0 11 8.9 19.9 19.9 19.9 1.2 0 2.4-.1 3.6-.3C41.7 43.2 36 46 29.7 46 18 46 8.5 36.5 8.5 24.8S18 3.6 29.7 3.6z" fill-rule="nonzero"/>'
}
